module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<h5>Caractéristiques de l\'intrant</h5>\r\n<hr class="border-green">\r\n\r\n<div class=\'form-row\'>\r\n    ';
 for (let property in rawMaterialProperties){;
__p += '\r\n    ';
let item = rawMaterialProperties[property];;
__p += '\r\n    <div class="form-group col-lg-3 col-md-6">\r\n        <label for="' +
((__t = (property)) == null ? '' : __t) +
'">' +
((__t = (item.name)) == null ? '' : __t) +
'</label>\r\n        <div class="input-group">\r\n            <input type="number" class="form-control" name="' +
((__t = (property)) == null ? '' : __t) +
'" min="0" step="0.0001" ' +
((__t = (property != 'potentialMethane' ? 'max="100"' : '')) == null ? '' : __t) +
' required>\r\n            <div class="input-group-apend">\r\n            ';
let unitData = unitList[item.unit];
__p += '\r\n                <span class="input-group-text">' +
((__t = (unitData ? unitData.unit :  item.unit)) == null ? '' : __t) +
'</span>\r\n            </div>\r\n        </div>\r\n    </div>\r\n    ';
};
__p += '\r\n</div>';

}
return __p
}